import { Injectable } from '@angular/core';
import { Urls } from '../utilities/urls.component';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';

@Injectable()
export class CustomFilterService {
  action: string;
  countriesList: any[] = [];
  showReceiveCountriesFlag: any;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {}

  // getAction() {
  //   return this.action;
  // }
  // setAction(page) {
  //   this.action = page;
  // }
  addNewCustomFilter(req: any) {
    var url: string = Urls.API_ENDPOINT + Urls.CUSTOM_FILTER.addNewCustomFilter;
    return this.http.post(url, req, this.headers.getCommonHttpHeaders());
  }
  getCustomReportFilters(req: any) {
    var url: string = Urls.API_ENDPOINT + Urls.CUSTOM_FILTER.getCustomReportFilters;
    return this.http.post(url, req, this.headers.getCommonHttpHeaders());
  }
  updateCustomFilter(req: any) {
    var url: string = Urls.API_ENDPOINT + Urls.CUSTOM_FILTER.updateCustomFilter;
    return this.http.post(url, req, this.headers.getCommonHttpHeaders());
  }
  checkDuplicateName(req: any) {
    var url: string = Urls.API_ENDPOINT + Urls.CUSTOM_FILTER.checkDuplicateName;
    return this.http.post(url, req, this.headers.getCommonHttpHeaders());
  }
  deleteFilter(req: any) {
    var url: string = Urls.API_ENDPOINT + Urls.CUSTOM_FILTER.deleteFilter;
    return this.http.post(url, req, this.headers.getCommonHttpHeaders());
  }
  sendEnterpriseCustomDateNotification(req: any) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.CUSTOMERREPORT.sendEnterpriseCustomDateNotification;
    return this.http.post(url, req, this.headers.getCommonHttpHeaders('v2_api'));
  }
  getFilterTypeByPage(page: any) {
    let filterType;
    switch (page) {
      case 'transactions':
        filterType = 'Transaction';
        break;
      case 'trans':
        filterType = 'Transaction';
        break;
      case 'balance':
        filterType = 'Balance';
        break;
      case 'bal':
        filterType = 'Balance';
        break;
      case 'dashboard':
        filterType = 'Value_volume_hub';
        break;
      case 'volumes':
        filterType = 'Value_volume_hub';
        break;
      case 'enterprise-transactions-report':
        filterType = 'Enterprise-Transaction';
        break;
      case 'enterprise-balance-report':  
        filterType = 'Enterprise-Balance';
        break;
    }
    console.log('filterType', filterType);
    return filterType;
  }
}
